import { useCallback } from 'react';
import { useTreeSync } from '../contexts/TreeSyncContext';

/**
 * Hook for synchronizing tree updates when requirements are modified
 * Listens for requirement modification events and triggers tree refresh
 */
const useRequirementsSync = () => {
  const { triggerRefresh } = useTreeSync();

  /**
   * Notify that a requirement has been modified
   * @param {string} requirementId - ID of the modified requirement
   * @param {string} action - Type of modification (create, update, delete)
   */
  const notifyRequirementModified = useCallback((requirementId, action = 'update') => {
    console.log(`Requirement ${requirementId} ${action}d, triggering tree refresh`);
    triggerRefresh(requirementId);
  }, [triggerRefresh]);

  /**
   * Notify that multiple requirements have been modified
   * @param {Array} requirementIds - Array of modified requirement IDs
   * @param {string} action - Type of modification
   */
  const notifyRequirementsModified = useCallback((requirementIds, action = 'update') => {
    if (Array.isArray(requirementIds)) {
      requirementIds.forEach(id => notifyRequirementModified(id, action));
    }
  }, [notifyRequirementModified]);

  return {
    notifyRequirementModified,
    notifyRequirementsModified
  };
};

export default useRequirementsSync;